export default __webpack_public_path__ + "static/media/fleet.c283904b.svg";